import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { IconsModule, LinkModule, icoYattaLogo } from '@platform-frontend/ui-tools';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { LegalWordingPipe } from './legal-wording.pipe';
import { PoweredByFooterComponent } from './powered-by-footer/powered-by-footer.component';
import { SimpleCopyrightFooterComponent } from './simple-copyright-footer/simple-copyright-footer.component';

@NgModule({
  declarations: [LegalWordingPipe, PoweredByFooterComponent, SimpleCopyrightFooterComponent],
  imports: [CommonModule, IconsModule.withIcons(icoYattaLogo), LinkModule, MatomoTrackClickDirective, TranslocoModule],
  exports: [LegalWordingPipe, PoweredByFooterComponent, SimpleCopyrightFooterComponent]
})
export class LegalModule {}
